import { render } from "./CreateProjectDataType.vue?vue&type=template&id=0dd440aa"
import script from "./CreateProjectDataType.vue?vue&type=script&lang=js"
export * from "./CreateProjectDataType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/CreateProjectDataType.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dd440aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dd440aa', __exports__)) {
    api.reload('0dd440aa', __exports__)
  }
  
  module.hot.accept("./CreateProjectDataType.vue?vue&type=template&id=0dd440aa", () => {
    api.rerender('0dd440aa', render)
  })

}


export default __exports__